import React, { useState } from 'react';
import { Table, Typography } from 'antd';
import CustomDateRangePicker from "../../components/customDateRangePicker";
import { fetchPaymentClose } from '../../apis/paymentsApi';
import { formatCurrency } from '../../utils/Formating';

const { Title } = Typography;

const AccountingClose = () => {
  const [totalAmount, setTotalAmount] = useState('');
  const [transactionsPerCategory, setTransactionsPerCategory] = useState([]);
  const [transactionsPerPaymentMethod, setTransactionsPerPaymentMethod] = useState([]);

  const fetchAccountingClose = async (startDate, endDate) => {
    const result = await fetchPaymentClose(startDate, endDate);
    setTotalAmount(result.totalAmount);
    setTransactionsPerCategory(result.transactionsPerCategoryMethod);
    setTransactionsPerPaymentMethod(result.transactionsPerPaymentMethod);
  };

  const columnsPaymentMethods = [
    {
      title: 'Método de Pago',
      dataIndex: 'payment_method_name',
      key: 'payment_method_name',
      align: 'center',
      render: (text) => text || 'N/A',
    },
    {
      title: 'Total Monto',
      dataIndex: 'total_amount',
      key: 'total_amount',
      align: 'center',
      render: (amount) => formatCurrency(amount),
    },
  ];

  const columnsCategories = [
    {
      title: 'Categoría',
      dataIndex: 'category_name',
      key: 'category_name',
      align: 'center',
      render: (text) => text || 'N/A',
    },
    {
      title: 'Total Monto',
      dataIndex: 'total_amount',
      key: 'total_amount',
      align: 'center',
      render: (amount) => formatCurrency(amount),
    },
  ];

  return (
    <div className='mobile-block themed-block p-5'>
      <Title level={2} className='text-center'>Contabilidad</Title>
      <CustomDateRangePicker months={2} maxDate={new Date()} onDateChange={fetchAccountingClose} className="mb-5"/>
      {totalAmount ? <Title level={5} className='text-center'>Total: {formatCurrency(totalAmount)}</Title> : ''}

      <Title level={4} className='text-center'>Medios de Pago</Title>
      <Table
        dataSource={transactionsPerPaymentMethod}
        columns={columnsPaymentMethods}
        rowKey="payment_method_id"
        bordered
        pagination={false}
      />

      <Title level={4} className='text-center'>Categorías</Title>
      <Table
        dataSource={transactionsPerCategory}
        columns={columnsCategories}
        rowKey="category_id"
        bordered
        pagination={false}
      />
    </div>
  );
};

export default AccountingClose;
